<template>
  <v-card
    class="vehicleApp"
  >
    <v-row
      class="vehicleApp-header"
      justify="center"
    >
      <v-col
        cols="5"
        sm="5"
        class="pa-0 text-center col-xs-3"
      >
        <v-img
          v-if="service.iconUrl"
          :aspect-ratio="1/1"
          :src="service.iconUrl"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-3"
              />
            </v-row>
          </template>
        </v-img>
        <v-icon
          v-else
          class="default-icon"
        >
          mdi-application
        </v-icon>
      </v-col>
      <v-col cols="12">
        <h2 class="text-center">
          {{ service.name }}
        </h2>
      </v-col>
      <v-col class="description text-justify px-lg-3 px-md-0 px-3">
        <span v-html="service.title || service.description" />
      </v-col>

      <v-col
        cols="12"
        class="text-center"
      >
        <v-btn
          class="see-apps"
          @click="showIncludedApps"
        >
          {{ $t('vehicleApps_overview.txt.see_bundle_apps') }}
        </v-btn>
      </v-col>
    </v-row>

    <div
      class="vehicleApp-footer"
    >
      <v-row>
        <v-col
          cols="12"
          class="px-2 py-0"
        >
          <v-btn
            :to="{ name: 'vehicle-app-detail', params: { id: service.id, catalog: inVehicleAppCatalog }}"
            :disabled="( trucks && trucks.length===0)"
            depressed
            large
            class="add-athlete"
            :class="(trucks && trucks.length>0) ? 'enabled' : 'disabled'"
          >
            {{ $t('services_overview.txt.add_vehicles') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-dialog
      v-model="isDialogVisible"
      max-width="800"
      content-class="more-dialog"
      @click="isDialogVisible = !isDialogVisible"
    >
      <v-card class="dialog-card">
        <div class="dialog-card-header">
          <v-img
            v-if="service.iconUrl"
            :src="service.iconUrl"
            width="30"
            class="dialog-card-header-icon"
          />
          <h2>{{ service.name }}</h2>
          <v-btn
            icon
            class="dialog-card-header-close"
            @click="
              isDialogVisible = !isDialogVisible
            "
          >
            <v-icon
              width="18"
              color="reddish"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </div>
        <div class="dialog-card-content">
          <v-row v-if="loadingIncludedApps">
            <v-col>
              <div

                class="loader"
              >
                <v-progress-circular
                  indeterminate
                  color="primary"
                />
              </div>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col v-if="!includedApps || includedApps.length == 0">
              <div class="no-results">
                <v-icon>
                  mdi-checkbox-blank-badge
                </v-icon>
              </div>
            </v-col>
            <v-col
              v-for="libraryApp in includedApps"
              v-else
              :key="libraryApp.id"
              cols="4"
            >
              <AppLibraryMinimalCard
                :library-app="libraryApp"
              />
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import appLibraryService from '@/helpers/appLibraryService'
import { mapState } from 'vuex'
import AppLibraryMinimalCard from '@/components/VehicleApps/AppLibraryMinimalCard.vue'

export default {
  name: 'VehicleAppsCard',
  components: {
    AppLibraryMinimalCard
  },
  props: {
    service: {
      type: Object,
      default: () => ({})
    },
    inVehicleAppCatalog: {
      type: [Array, Object],
      default: () => []
    }
  },
  data() {
    return {
      isDialogVisible: false,
      loadingIncludedApps: false,
      includedApps: []
    }
  },
  computed: {
    ...mapState('account', ['currency', 'accountInformation']),
    ...mapState('trucks', ['trucks'])
  },
  methods: {
    async showIncludedApps() {
      this.isDialogVisible = true
      if (!this.includedApps.length) {
        this.loadingIncludedApps = true

        this.includedApps = await appLibraryService.getAppsForPack(
          this.service.sku
        )

        this.loadingIncludedApps = false
      }
    }
  }
}
</script>

<style lang="scss">
.vehicleApp {
  padding: 16px 32px 70px;
  height: 100%;
  vertical-align: bottom;
  border-radius: 8px !important;
  box-shadow: 0 1px 2px 0 #00000033;

  .default-icon {
    font-size: 80px;
    color: var(--v-cloudy-base);
  }
  .see-apps {
    box-shadow: none;
    background: none !important;

    span {
      color: #005ca9;
    }
  }

  &-header {
    h2 {
      font-weight: bold;
      font-size: 1.25rem;
      color: var(--v-slate-base);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span {
      font-size: 0.875rem;
      color: var(--v-bluegrey-base);
    }
    .description {
      font-size: 0.875rem;
      color: var(--v-bluegrey-base);
      line-height: 1.25;
      p {
        font-size: 0.875rem;
        color: var(--v-bluegrey-base);
        text-align: justify;
      }
    }
  }
  &-footer {
    // height: 160px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px;
    background-color: var(--v-pale-two-base);
    font-size: 1rem;
    color: var(--v-slate-base);

    span {
      font-size: 0.75rem;
    }

    .label {
      font-size: 0.75rem;
      font-weight: bold;
      text-transform: uppercase;
      color: var(--v-bluegrey-base);
    }

    .add-athlete {
      height: 64px !important;
      width: 100%;

      span {
        font-size: 1.125rem;
        font-weight: bold;
        color: white;
      }
      &.enabled {
        background-image: linear-gradient(to bottom, #266cab 0%, #01529c);
      }
      &.disabled {
        background-color: var(--v-cloudy-base) !important;
        background-image: none;
      }
    }

    .status-label {
      font-size: 1rem;
      font-weight: bold;
    }
  }
}
</style>